import { NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export const importantPushEnum: NotificationType[] = [NotificationType.LIVECHAT_INVITATION];
